var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21967 0.46967C0.512563 0.176777 0.987437 0.176777 1.28033 0.46967L7.28033 6.46967C7.57322 6.76256 7.57322 7.23744 7.28033 7.53033L1.28033 13.5303C0.987437 13.8232 0.512563 13.8232 0.21967 13.5303C-0.0732233 13.2374 -0.0732233 12.7626 0.21967 12.4697L5.68934 7L0.21967 1.53033C-0.0732233 1.23744 -0.0732233 0.762563 0.21967 0.46967Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIconOrange);
export default __webpack_public_path__ + "static/media/chevron_icon_orange.2bd91590c8248142c62810ef18fe448b.svg";
export { ForwardRef as ReactComponent };